import { render, staticRenderFns } from "./AboutUsTimeLine.vue?vue&type=template&id=470bb6d4&scoped=true&"
import script from "./AboutUsTimeLine.vue?vue&type=script&lang=js&"
export * from "./AboutUsTimeLine.vue?vue&type=script&lang=js&"
import style0 from "./AboutUsTimeLine.vue?vue&type=style&index=0&id=470bb6d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470bb6d4",
  null
  
)

export default component.exports